import React, { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { LOOKUP_SESSION_WITH_RECORDING_AND_HEALTH_DATA } from "../../../queries/GraphQLQueries";
import { SESSION_HEALTH_DATA_POLLING_RATE_IN_SECONDS } from "../../../constants/SessionConstants";
import SessionHealthDetail from "../../availability/SessionHealthDetail";
import {COMPACT_CHIP_STYLE} from "../../../helpers/SessionHealthChipStylesHelper";

export default function SessionHealthDataFetcher({ session, options }) {
  const [sessionHealthDetail, setSessionHealthDetail] = useState();
  const [lookupSessionHealth, { data: healthData }] = useLazyQuery(
    LOOKUP_SESSION_WITH_RECORDING_AND_HEALTH_DATA,
    {
      pollInterval: SESSION_HEALTH_DATA_POLLING_RATE_IN_SECONDS,
      fetchPolicy: 'network-only'
    }
  );

  useEffect(() => {
    if (session && session.id) {
      lookupSessionHealth({ variables: { sessionId: session.id } });
    }
  }, [session, lookupSessionHealth]);

  useEffect(() => {
    if (healthData && healthData?.sessionInfo) {
      setSessionHealthDetail(healthData.sessionInfo);
    }
  }, [healthData]);

  return (
    <>
      {sessionHealthDetail && (
        <SessionHealthDetail session={sessionHealthDetail} options={options} chipStyles={COMPACT_CHIP_STYLE}/>
      )}
    </>
  );
}